import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        fontFamily:
          "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
        lineHeight: "1.6",
        color: "#111",
        padding: "28px",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      <header>
        <h1 style={{ color: "#0b3b6f" }}>Privacy Policy</h1>
        <p style={{ marginBottom: "8px", color: "#666" }}>
          Last updated: December 13, 2023
        </p>
        <p style={{ fontSize: "0.9rem", color: "#555" }}>
          This Privacy Policy explains how we collect, use, and share your
          personal information when you use our platform.
        </p>
      </header>

      <main>
        <h2 style={{ color: "#0b3b6f" }}>Scope</h2>
        <p>
          This policy applies to all users (Riders and Drivers) and to all our
          apps, websites, and platform services. It covers personal information
          (not aggregated or anonymized data).
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Information We Collect</h2>
        <ul>
          <li>
            <strong>Information you provide:</strong> account registration data
            (name, email, phone), payment info, profile photo, identity docs for
            drivers.
          </li>
          <li>
            <strong>Usage & location:</strong> ride details (pickup/dropoff),
            GPS location while using the app, device and usage data.
          </li>
          <li>
            <strong>Communications:</strong> messages/calls routed via
            third-party providers; we may log metadata and contents where
            notified.
          </li>
          <li>
            <strong>From others:</strong> background check providers, payment
            processors, partners, and linked enterprise programs.
          </li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>How We Use Your Information</h2>
        <p>
          We use data to operate and improve the service, verify identity,
          process payments, provide customer support, maintain safety, and
          comply with legal obligations.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>How We Share Information</h2>
        <p>We do not sell personal information. We may share data:</p>
        <ul>
          <li>
            Between Riders and Drivers for service facilitation (e.g., rider
            pickup info, driver vehicle info).
          </li>
          <li>
            With service providers to process payments, verify identity, and
            provide analytics.
          </li>
          <li>
            To comply with legal requests or to protect rights and safety.
          </li>
          <li>During mergers or asset sales, as permitted by law.</li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>Data Retention & Security</h2>
        <p>
          We retain data as necessary to provide services, meet legal
          obligations, and for legitimate business needs (transaction records
          kept at least 7 years where applicable). We implement reasonable
          security controls but cannot guarantee 100% security.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Your Rights & Choices</h2>
        <ul>
          <li>Access and edit profile data via account settings.</li>
          <li>
            Opt-out of promotional emails and texts via the methods described in
            account communications.
          </li>
          <li>
            Delete your account via the privacy homepage; certain records may be
            retained for legal or business reasons.
          </li>
          <li>
            Control device location sharing via device settings (note: disabling
            may limit functionality).
          </li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>Children</h2>
        <p>
          We do not knowingly collect personal data from children under 16. If
          discovered, we will take steps to delete such data.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Changes to this Policy</h2>
        <p>
          We may update this policy; material changes will be communicated via
          the app or email. Continued use implies acceptance of the updated
          policy.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Contact</h2>
        <p>
          If you have questions about privacy or need the policy in another
          format, contact us through our Help Center or email{" "}
          <a href="mailto:privacy@example.com">privacy@example.com</a>.
        </p>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
